var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m355.595 128.533h-308.462c-26.278 0-47.133 21.325-47.133 47.134v160.667c0 26.278 21.325 47.133 47.133 47.133h308.461v-254.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.866 128.533h-19.271v254.934h19.271c26.278 0 47.134-21.325 47.134-47.133v-160.667c0-26.34-21.392-47.134-47.134-47.134z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.723 417.734c-9.447 0-17.128-7.686-17.128-17.133v-289.201c0-9.455 7.674-17.133 17.112-17.133 8.284 0 15.008-6.716 15.008-15-1.945-25.032-36.118-13.691-47.12-2.331-10.99-11.358-45.184-22.701-47.12 2.331 0 8.284 6.724 15 15.008 15 9.438 0 17.112 7.679 17.112 17.133v289.2c0 9.447-7.681 17.133-17.128 17.133-8.284 0-15 6.716-15 15 1.952 25.031 36.123 13.693 47.128 2.323 8.424 7.86 19.725 12.677 32.128 12.677 19.875-.734 19.87-29.267 0-29.999z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRename);
export default __webpack_public_path__ + "static/media/icon-rename.58ba5422b45d5e18e324a14382d70a8d.svg";
export { ForwardRef as ReactComponent };